import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4ZM20 14V6H4V14H7.76C8.06947 14.0009 8.3711 14.0974 8.62353 14.2765C8.87596 14.4555 9.06684 14.7082 9.17 15C9.37614 15.586 9.7591 16.0935 10.266 16.4526C10.7729 16.8116 11.3788 17.0045 12 17.0045C12.6212 17.0045 13.2271 16.8116 13.734 16.4526C14.2409 16.0935 14.6239 15.586 14.83 15C14.9332 14.7082 15.124 14.4555 15.3765 14.2765C15.6289 14.0974 15.9305 14.0009 16.24 14H20Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgArchive = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgArchive;
